function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/Modal';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
var _React_PureComponent;
class ResendInvitationModal extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { isInProgress, hasErrors } = props;
        if (isInProgress && !state.isInProgress) {
            return {
                isInProgress: true
            };
        }
        if (hasErrors && state.isInProgress) {
            return {
                isInProgress: false
            };
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        const { isInProgress, hasErrors } = this.props;
        if (prevProps.isInProgress !== isInProgress && !isInProgress && !hasErrors) {
            this.onClose();
        }
    }
    async onClose() {
        await this.props.onCloseModal();
        this.setState({
            isInProgress: false
        });
    }
    render() {
        const { sharingRequest, activePatient } = this.props;
        if (!sharingRequest || !activePatient) {
            return null;
        }
        return /*#__PURE__*/ _jsxs(Modal, {
            modalId: constants.RESEND_INVITATION_PATIENT_MODAL,
            openModalId: this.props.openModalId,
            styleModifier: "md",
            headerMessage: messages.headers.resendInvitation,
            onClose: ()=>this.onClose(),
            children: [
                /*#__PURE__*/ _jsxs("p", {
                    className: "text--large text--bold mb-2",
                    children: [
                        activePatient.firstName,
                        " ",
                        activePatient.lastName
                    ]
                }),
                /*#__PURE__*/ _jsx("p", {
                    children: activePatient.email
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "modal__info mt-4",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.resendInvitation))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "modal__actions row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ _jsx(Button, {
                                styleModifier: "quaternary",
                                labelMessage: messages.buttons.resendInvitationReject,
                                className: "btn--block mt-5",
                                isDisabled: this.state.isInProgress,
                                onClick: ()=>this.onClose()
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ _jsx(Button, {
                                styleModifier: "primary",
                                labelMessage: messages.buttons.resendInvitationConfirm,
                                className: "btn--block btn--filled mt-5",
                                isInProgress: this.state.isInProgress,
                                onClick: ()=>this.props.onResendInvitationEmail(this.props.sharingRequest)
                            })
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isInProgress: false
        };
    }
}
_define_property(ResendInvitationModal, "propTypes", {
    // Implicit props
    sharingRequest: PropTypes.object,
    activePatient: PropTypes.object,
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    openModalId: PropTypes.string,
    // Implicit actions
    onResendInvitationEmail: PropTypes.func,
    onCloseModal: PropTypes.func
});
const mapStateToProps = (state)=>({
        openModalId: App.selectors.modal(state),
        isInProgress: selectors.isResendInvitationPatientInProgress(state),
        hasErrors: selectors.resendInvitationPatientErrors(state),
        sharingRequest: selectors.sharingRequest(state),
        activePatient: selectors.activePatient(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onResendInvitationEmail: (sharingRequest)=>dispatch(actions.resendSharingRequest(sharingRequest)),
        onCloseModal: ()=>dispatch(App.actions.closeModal())
    });
const ConnectedResendInvitationModal = connect(mapStateToProps, mapDispatchToProps)(ResendInvitationModal);
export default ConnectedResendInvitationModal;
